import React, { useState } from 'react';
import './ImageGallery.css';

const ImageGallery = ({ images, onClose }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  if (!images || images.length === 0) {
    return (
      <div className="gallery-container">
        <div className="gallery-header">
          <h2>📷 Фотоальбом</h2>
          <button className="gallery-close" onClick={onClose}>✕</button>
        </div>
        <div className="gallery-empty">В этом канале пока нет изображений</div>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <h2>📷 Фотоальбом ({images.length})</h2>
        <button className="gallery-close" onClick={onClose}>✕</button>
      </div>
      
      <div className="gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="gallery-item">
            <img 
              src={img.url} 
              alt={img.fileName} 
              className="gallery-image"
              onClick={() => openModal(img)}
            />
            <div className="gallery-item-tooltip">
              {img.fileName}
            </div>
          </div>
        ))}
      </div>

      {/* Модальное окно для увеличенного изображения */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={closeModal}>✕</button>
            <img 
              src={selectedImage.url} 
              alt={selectedImage.fileName} 
              className="gallery-modal-image"
            />
            <div className="gallery-modal-caption">
              {selectedImage.fileName}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;